// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ankiDeck {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 1em 0;
  background: var(--raised);
  border-radius: 8px;
  padding: 16px;
  outline: none;
}

.viewMarkdownDiv .ankiDeckHeader > h3 {
  margin: 0;
  padding: 0;
}

.ankiDeck[data-mode='study']:focus-within {
  box-shadow: inset 0 0 0 2px var(--accent);
}

.ankiDeckOptionsButton,
.ankiDeckModeToggle {
  align-self: flex-start;
}

.ankiDeckList {
  display: flex;
  flex-direction: column;
}

.ankiDeckListRow {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  padding: 8px 0;
}

.ankiDeckListRow + .ankiDeckListRow {
  border-top: 1px solid var(--line);
}

.ankiDeckListQuestion {
  font-weight: 600;
}

.ankiDeckEmpty {
  color: var(--muted);
}

.ankiDeckCarouselTop {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.ankiDeckOptionsMenu {
  position: absolute;
  z-index: 10;
  background: #fff;
  border: 1px solid #bfb8b2;
  border-radius: 8px;
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.15);
  padding: 15px;
  display: grid;
  gap: 8px;
  font-size: var(--font-size-small);
}

.ankiDeckOptionsGroup {
  display: flex;
  border: 1px solid var(--line-strong);
  border-radius: var(--button-border-radius);
  background: var(--selection-hover);
}

.ankiDeckOptionsGroupButton {
  position: relative;
  flex: 1;
  margin: 0;
  padding: 0.2em 0.5em;
  border: none;
  background: none;
  color: var(--ink);
  font-family: system-ui, sans-serif;
  font-size: var(--font-size-small);
  line-height: 1.2;
  cursor: pointer;
}

.ankiDeckOptionsGroupButton:first-child {
  border-radius: calc(var(--button-border-radius) - 1px) 0 0
    calc(var(--button-border-radius) - 1px);
}

.ankiDeckOptionsGroupButton:last-child {
  border-radius: 0 calc(var(--button-border-radius) - 1px)
    calc(var(--button-border-radius) - 1px) 0;
}

.ankiDeckOptionsGroupButton + .ankiDeckOptionsGroupButton {
  border-left: 1px solid var(--line-strong);
}

.ankiDeckOptionsGroupButton:hover {
  color: var(--accent-strong);
}

.ankiDeckOptionsGroupButton:focus-visible {
  z-index: 1;
  outline: var(--outline-focus);
}

.ankiDeckOptionsGroupButton:active {
  z-index: 1;
  outline: var(--outline-active);
}

.ankiDeckOptionsGroupButton-active,
.ankiDeckOptionsGroupButton-active:hover {
  background: var(--accent);
  color: #fff;
}

.ankiDeckOptionsRandom {
  display: flex;
  align-items: center;
  gap: 4px;
}

.ankiDeckCarouselProgress {
  color: var(--muted);
  font-size: 11px;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-variant-numeric: tabular-nums;
}

.ankiDeckCarouselNav {
  display: flex;
  gap: 6px;
}

.ankiDeckCarouselNavButton {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  padding: 0;
  font-size: 13px;
  line-height: 1;
}

.ankiDeckCarouselShowNext {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 26px;
  padding: 0;
}

.ankiDeckCarouselGrade {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 52px;
  height: 26px;
  padding: 0 8px;
}

.ankiDeckSummary {
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
}

.ankiDeckSummaryStats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(110px, 1fr));
  gap: 12px 24px;
  margin: 8px 0;
  text-align: center;
}

.ankiDeckSummaryStats dt {
  color: var(--muted);
  font-size: 11px;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.ankiDeckSummaryStats dd {
  margin: 4px 0 0;
  font-size: 24px;
  font-variant-numeric: tabular-nums;
}

.ankiDeckSummaryCardsWrap {
  border: 1px solid var(--line);
  border-radius: 8px;
  max-height: 320px;
  overflow-y: auto;
}

.ankiDeckSummary .ankiDeckSummaryCards {
  display: table;
  width: 100%;
  margin: 0;
  border-collapse: collapse;
  font-size: var(--font-size-small);
  font-variant-numeric: tabular-nums;
}

.ankiDeckSummary .ankiDeckSummaryCards th,
.ankiDeckSummary .ankiDeckSummaryCards td {
  padding: 10px 14px;
  border: none;
  text-align: right;
}

.ankiDeckSummary .ankiDeckSummaryCards tbody tr:nth-child(even) {
  background: var(--accent-tint);
}

.ankiDeckSummary .ankiDeckSummaryCards th {
  position: sticky;
  top: 0;
  background: var(--accent-wash);
  color: var(--muted);
  font-size: 11px;
  font-weight: normal;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.ankiDeckSummary .ankiDeckSummaryCards th:first-child,
.ankiDeckSummary .ankiDeckSummaryCards td:first-child {
  width: 100%;
  max-width: 0;
  overflow: hidden;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ankiDeckSummary .ankiDeckSummaryCards th:last-child,
.ankiDeckSummary .ankiDeckSummaryCards td:last-child {
  width: 40%;
  min-width: 140px;
}

.ankiDeckSummaryZero {
  color: var(--line-strong);
}

.ankiDeckSummaryTime {
  display: flex;
  align-items: center;
  gap: 8px;
}

.ankiDeckSummaryTimeTrack {
  flex: 1;
}

.ankiDeckSummaryTimeBar {
  height: 8px;
  background: var(--accent);
}

.ankiDeckSummaryPill {
  display: inline-block;
  min-width: 18px;
  margin-left: 8px;
  padding: 0 6px;
  border-radius: 999px;
  background: #fff3;
  font-size: 12px;
  font-variant-numeric: tabular-nums;
  line-height: 18px;
  text-align: center;
}

.ankiDeckSummaryActions {
  display: flex;
  gap: 8px;
}

.ankiDeckCarouselProgressRow {
  display: flex;
  align-items: center;
  gap: 12px;
}

.ankiDeckCarouselBar {
  position: relative;
  flex: 1;
  height: 8px;
  border-radius: 999px;
  overflow: hidden;
  background: var(--line);
}

.ankiDeckCarouselFill {
  position: absolute;
  inset: 0 auto 0 0;
  transition: width 0.2s;
}

.ankiDeckCarouselFill[data-fill='mastered'] {
  z-index: 1;
  width: calc(var(--mastered) * 100%);
  background: var(--accent);
}

.ankiDeckCarouselFill[data-fill='retry'] {
  width: calc((var(--mastered) + var(--retry)) * 100%);
  background: repeating-linear-gradient(
    135deg,
    var(--accent) 0 2px,
    var(--accent-wash) 2px 4px
  );
  background-size: 100vw 100%;
  background-repeat: no-repeat;
}

.ankiDeckCarouselStage {
  display: flex;
}

.ankiDeckCardFront {
  font-weight: 600;
  margin-bottom: 8px;
}

.ankiDeckCardBack {
  margin-top: 10px;
}

.ankiDeckCardStage {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  background: #fff;
  border: 1px solid var(--line);
  border-radius: 8px;
  box-shadow: 0 1px 3px #0000000d;
  padding: 40px 24px;
  text-align: center;
}

.ankiDeckCardStage .ankiDeckCardFront {
  font-family: var(--font-display);
  font-size: 2.25em;
  font-weight: 600;
  line-height: 1.2;
  margin: 0;
}

.ankiDeckCardStage .ankiDeckCardBack {
  font-family: var(--font-display);
  font-size: 1.5em;
  color: var(--ink);
  margin: 0;
  opacity: 0;
  transition: opacity 80ms ease-out;
}

.ankiDeckCardStage .ankiDeckCardBackRevealed {
  opacity: 1;
}

.ankiDeckCardStage .ankiDeckClozeText {
  font-size: 1.25em;
  line-height: 1.5;
}

.ankiDeckClozeText {
  margin: 0;
}

.ankiDeckClozeBlank {
  margin: 0;
  padding: 0 2px;
  border: none;
  border-bottom: 1px dashed var(--accent-strong);
  background: none;
  color: var(--accent-strong);
  font: inherit;
  cursor: pointer;
}

.ankiDeckClozeBlank:hover {
  background: var(--accent-tint);
}

.ankiDeckHeader {
  line-height: 1;
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
}

.ankiDeckStats {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: var(--muted);
}

.ankiDeckStats span + span::before {
  content: '·';
  margin-right: 6px;
}

.ankiDeckCardTyped {
  box-sizing: border-box;
  width: 100%;
  max-width: 320px;
  margin: 0;
  padding: 8px 12px;
  border: 1px solid var(--line-strong);
  border-radius: var(--button-border-radius);
  background: #fff;
  color: var(--ink);
  font-family: inherit;
  font-size: 1.25em;
  line-height: 1.2;
  text-align: center;
}

.ankiDeckCardTyped:focus-visible {
  outline: var(--outline-focus);
}

.ankiDeckCardTyped[data-match='false'] {
  text-decoration: line-through;
}
`, "",{"version":3,"sources":["webpack://./src/frontend/components/AnkiDeck.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;EACb,aAAa;EACb,QAAQ;EACR,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,0CAA0C;EAC1C,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,kCAAkC;EAClC,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE;2CACyC;AAC3C;;AAEA;EACE;6CAC2C;AAC7C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,8BAA8B;AAChC;;AAEA;;EAEE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,cAAc;EACd,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,SAAS;EACT,yBAAyB;EACzB,iCAAiC;EACjC,kCAAkC;AACpC;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,kCAAkC;EAClC,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,WAAW;EACX,oBAAoB;EACpB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA;EACE,oDAAoD;EACpD;;;;GAIC;EACD,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,UAAU;EACV,iCAAiC;AACnC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;EACT,cAAc;EACd,YAAY;EACZ,8CAA8C;EAC9C,gBAAgB;EAChB,2BAA2B;EAC3B,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,iBAAiB;EACjB,oCAAoC;EACpC,0CAA0C;EAC1C,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B","sourcesContent":[".ankiDeck {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin: 1em 0;\n  background: var(--raised);\n  border-radius: 8px;\n  padding: 16px;\n  outline: none;\n}\n\n.viewMarkdownDiv .ankiDeckHeader > h3 {\n  margin: 0;\n  padding: 0;\n}\n\n.ankiDeck[data-mode='study']:focus-within {\n  box-shadow: inset 0 0 0 2px var(--accent);\n}\n\n.ankiDeckOptionsButton,\n.ankiDeckModeToggle {\n  align-self: flex-start;\n}\n\n.ankiDeckList {\n  display: flex;\n  flex-direction: column;\n}\n\n.ankiDeckListRow {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n  padding: 8px 0;\n}\n\n.ankiDeckListRow + .ankiDeckListRow {\n  border-top: 1px solid var(--line);\n}\n\n.ankiDeckListQuestion {\n  font-weight: 600;\n}\n\n.ankiDeckEmpty {\n  color: var(--muted);\n}\n\n.ankiDeckCarouselTop {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.ankiDeckOptionsMenu {\n  position: absolute;\n  z-index: 10;\n  background: #fff;\n  border: 1px solid #bfb8b2;\n  border-radius: 8px;\n  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.15);\n  padding: 15px;\n  display: grid;\n  gap: 8px;\n  font-size: var(--font-size-small);\n}\n\n.ankiDeckOptionsGroup {\n  display: flex;\n  border: 1px solid var(--line-strong);\n  border-radius: var(--button-border-radius);\n  background: var(--selection-hover);\n}\n\n.ankiDeckOptionsGroupButton {\n  position: relative;\n  flex: 1;\n  margin: 0;\n  padding: 0.2em 0.5em;\n  border: none;\n  background: none;\n  color: var(--ink);\n  font-family: system-ui, sans-serif;\n  font-size: var(--font-size-small);\n  line-height: 1.2;\n  cursor: pointer;\n}\n\n.ankiDeckOptionsGroupButton:first-child {\n  border-radius: calc(var(--button-border-radius) - 1px) 0 0\n    calc(var(--button-border-radius) - 1px);\n}\n\n.ankiDeckOptionsGroupButton:last-child {\n  border-radius: 0 calc(var(--button-border-radius) - 1px)\n    calc(var(--button-border-radius) - 1px) 0;\n}\n\n.ankiDeckOptionsGroupButton + .ankiDeckOptionsGroupButton {\n  border-left: 1px solid var(--line-strong);\n}\n\n.ankiDeckOptionsGroupButton:hover {\n  color: var(--accent-strong);\n}\n\n.ankiDeckOptionsGroupButton:focus-visible {\n  z-index: 1;\n  outline: var(--outline-focus);\n}\n\n.ankiDeckOptionsGroupButton:active {\n  z-index: 1;\n  outline: var(--outline-active);\n}\n\n.ankiDeckOptionsGroupButton-active,\n.ankiDeckOptionsGroupButton-active:hover {\n  background: var(--accent);\n  color: #fff;\n}\n\n.ankiDeckOptionsRandom {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.ankiDeckCarouselProgress {\n  color: var(--muted);\n  font-size: 11px;\n  font-weight: bold;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  font-variant-numeric: tabular-nums;\n}\n\n.ankiDeckCarouselNav {\n  display: flex;\n  gap: 6px;\n}\n\n.ankiDeckCarouselNavButton {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 26px;\n  height: 26px;\n  padding: 0;\n  font-size: 13px;\n  line-height: 1;\n}\n\n.ankiDeckCarouselShowNext {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 52px;\n  height: 26px;\n  padding: 0;\n}\n\n.ankiDeckCarouselGrade {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 52px;\n  height: 26px;\n  padding: 0 8px;\n}\n\n.ankiDeckSummary {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  width: 100%;\n}\n\n.ankiDeckSummaryStats {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(110px, 1fr));\n  gap: 12px 24px;\n  margin: 8px 0;\n  text-align: center;\n}\n\n.ankiDeckSummaryStats dt {\n  color: var(--muted);\n  font-size: 11px;\n  font-weight: bold;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.ankiDeckSummaryStats dd {\n  margin: 4px 0 0;\n  font-size: 24px;\n  font-variant-numeric: tabular-nums;\n}\n\n.ankiDeckSummaryCardsWrap {\n  border: 1px solid var(--line);\n  border-radius: 8px;\n  max-height: 320px;\n  overflow-y: auto;\n}\n\n.ankiDeckSummary .ankiDeckSummaryCards {\n  display: table;\n  width: 100%;\n  margin: 0;\n  border-collapse: collapse;\n  font-size: var(--font-size-small);\n  font-variant-numeric: tabular-nums;\n}\n\n.ankiDeckSummary .ankiDeckSummaryCards th,\n.ankiDeckSummary .ankiDeckSummaryCards td {\n  padding: 10px 14px;\n  border: none;\n  text-align: right;\n}\n\n.ankiDeckSummary .ankiDeckSummaryCards tbody tr:nth-child(even) {\n  background: var(--accent-tint);\n}\n\n.ankiDeckSummary .ankiDeckSummaryCards th {\n  position: sticky;\n  top: 0;\n  background: var(--accent-wash);\n  color: var(--muted);\n  font-size: 11px;\n  font-weight: normal;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.ankiDeckSummary .ankiDeckSummaryCards th:first-child,\n.ankiDeckSummary .ankiDeckSummaryCards td:first-child {\n  width: 100%;\n  max-width: 0;\n  overflow: hidden;\n  text-align: left;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.ankiDeckSummary .ankiDeckSummaryCards th:last-child,\n.ankiDeckSummary .ankiDeckSummaryCards td:last-child {\n  width: 40%;\n  min-width: 140px;\n}\n\n.ankiDeckSummaryZero {\n  color: var(--line-strong);\n}\n\n.ankiDeckSummaryTime {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.ankiDeckSummaryTimeTrack {\n  flex: 1;\n}\n\n.ankiDeckSummaryTimeBar {\n  height: 8px;\n  background: var(--accent);\n}\n\n.ankiDeckSummaryPill {\n  display: inline-block;\n  min-width: 18px;\n  margin-left: 8px;\n  padding: 0 6px;\n  border-radius: 999px;\n  background: #fff3;\n  font-size: 12px;\n  font-variant-numeric: tabular-nums;\n  line-height: 18px;\n  text-align: center;\n}\n\n.ankiDeckSummaryActions {\n  display: flex;\n  gap: 8px;\n}\n\n.ankiDeckCarouselProgressRow {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.ankiDeckCarouselBar {\n  position: relative;\n  flex: 1;\n  height: 8px;\n  border-radius: 999px;\n  overflow: hidden;\n  background: var(--line);\n}\n\n.ankiDeckCarouselFill {\n  position: absolute;\n  inset: 0 auto 0 0;\n  transition: width 0.2s;\n}\n\n.ankiDeckCarouselFill[data-fill='mastered'] {\n  z-index: 1;\n  width: calc(var(--mastered) * 100%);\n  background: var(--accent);\n}\n\n.ankiDeckCarouselFill[data-fill='retry'] {\n  width: calc((var(--mastered) + var(--retry)) * 100%);\n  background: repeating-linear-gradient(\n    135deg,\n    var(--accent) 0 2px,\n    var(--accent-wash) 2px 4px\n  );\n  background-size: 100vw 100%;\n  background-repeat: no-repeat;\n}\n\n.ankiDeckCarouselStage {\n  display: flex;\n}\n\n.ankiDeckCardFront {\n  font-weight: 600;\n  margin-bottom: 8px;\n}\n\n.ankiDeckCardBack {\n  margin-top: 10px;\n}\n\n.ankiDeckCardStage {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n  background: #fff;\n  border: 1px solid var(--line);\n  border-radius: 8px;\n  box-shadow: 0 1px 3px #0000000d;\n  padding: 40px 24px;\n  text-align: center;\n}\n\n.ankiDeckCardStage .ankiDeckCardFront {\n  font-family: var(--font-display);\n  font-size: 2.25em;\n  font-weight: 600;\n  line-height: 1.2;\n  margin: 0;\n}\n\n.ankiDeckCardStage .ankiDeckCardBack {\n  font-family: var(--font-display);\n  font-size: 1.5em;\n  color: var(--ink);\n  margin: 0;\n  opacity: 0;\n  transition: opacity 80ms ease-out;\n}\n\n.ankiDeckCardStage .ankiDeckCardBackRevealed {\n  opacity: 1;\n}\n\n.ankiDeckCardStage .ankiDeckClozeText {\n  font-size: 1.25em;\n  line-height: 1.5;\n}\n\n.ankiDeckClozeText {\n  margin: 0;\n}\n\n.ankiDeckClozeBlank {\n  margin: 0;\n  padding: 0 2px;\n  border: none;\n  border-bottom: 1px dashed var(--accent-strong);\n  background: none;\n  color: var(--accent-strong);\n  font: inherit;\n  cursor: pointer;\n}\n\n.ankiDeckClozeBlank:hover {\n  background: var(--accent-tint);\n}\n\n.ankiDeckHeader {\n  line-height: 1;\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.ankiDeckStats {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 14px;\n  color: var(--muted);\n}\n\n.ankiDeckStats span + span::before {\n  content: '·';\n  margin-right: 6px;\n}\n\n.ankiDeckCardTyped {\n  box-sizing: border-box;\n  width: 100%;\n  max-width: 320px;\n  margin: 0;\n  padding: 8px 12px;\n  border: 1px solid var(--line-strong);\n  border-radius: var(--button-border-radius);\n  background: #fff;\n  color: var(--ink);\n  font-family: inherit;\n  font-size: 1.25em;\n  line-height: 1.2;\n  text-align: center;\n}\n\n.ankiDeckCardTyped:focus-visible {\n  outline: var(--outline-focus);\n}\n\n.ankiDeckCardTyped[data-match='false'] {\n  text-decoration: line-through;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
